import { PrismicNextImage } from "@prismicio/next";

/**
 * @typedef {import("@prismicio/client").Content.BlogSliceInfoPrimary} InfoPrimary
 * @param {{ primary: InfoPrimary }} props
 */
const Info = ({ primary }) => (
  <div className="flex flex-row gap-[30px] bg-vert-10 py-10 px-[30px] rounded-[20px]">
    <div className="w-10 h-10 bg-vert-50 p-1 rounded mt-1 flex justify-center items-center">
      <PrismicNextImage field={primary.icon} className="w-6 h-6 object-contain object-center" />
    </div>
    <p className="text-bleu p-blog font-medium flex-1">{primary.text}</p>
  </div>
);

export default Info;
